import React from 'react'
import { AgGridReact } from "ag-grid-react";
import ModalBasic from '../../component/ModalBasic';
import TextInput from '../../../components/UIComponent/TextInput';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.09,
        flex: 0.9,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "idMaterialPlanning",
        headerName: "ID Material Planning",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

export const WorkPlanningPopup = (props) => {
    return (
        <ModalBasic
            id="work-planning"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Details for work planning</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Planning no</label>
                        <TextInput type='text'
                            id='planningNo' name='planningNo'
                            value={props.workObject.planningNo}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'planningNo')}
                            className={props.validState?.error?.planningNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Planning date</label>
                        <TextInput type='date'
                            id='planningDate' name='planningDate'
                            value={props.workObject.planningDate}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'planningDate')}
                            className={props.validState?.error?.planningDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Auth. employee</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select employee"
                            options={props.workObject.EmployeeList}
                            value={props.workObject.idEmployee ? props.workObject.EmployeeList.find(x => x.value === props.workObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idEmployee", 'workObject')
                            }
                            className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                        /> */}
                        <TextInput type='text'
                            id='usp_Users' name='usp_Users'
                            value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                            disabled={true}
                        // handleChange={(event) => props.handleChangeForWork(event, 'personName')}
                        // className={props.validState?.error?.personName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Priority</label>
                        <MultiSelectDropdown
                            drpIdentity="Select priority"
                            options={props.workObject.priorityList}
                            value={props.workObject.idPriority ? props.workObject.priorityList.find(x => x.value === props.workObject.idPriority) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPriority", 'workObject')
                            }
                            className={props.validState?.error?.idPriority !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select work order</label>
                        <MultiSelectDropdown
                            drpIdentity="Select wo"
                            options={props.workObject.workOrderList}
                            value={props.workObject.idWorkOrder ? props.workObject.workOrderList.find(x => x.value === props.workObject.idWorkOrder) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idWorkOrder", 'workObject')
                            }
                            className={props.validState?.error?.idWorkOrder !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.generate()}>Generate</button>
                    </div>

                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChangeForItem(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.itemObject.TypeList}
                            value={props.itemObject.idType ? props.itemObject.TypeList.find(x => x.value === props.itemObject.idType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idType", 'itemObject')
                            }
                            className={props.validState?.error?.idType !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        <MultiSelectDropdown
                            drpIdentity="Select priority"
                            options={props.itemObject.ItemList}
                            value={props.itemObject.idItem ? props.itemObject.ItemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItem", 'itemObject')
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChangeForItem(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Planning no</label>
                        <MultiSelectDropdown
                            drpIdentity="Select planning"
                            options={props.itemObject.planningList}
                            value={props.itemObject.idPlanning ? props.itemObject.planningList.find(x => x.value === props.itemObject.idPlanning) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPlanning", 'itemObject')
                            }
                            className={props.validState?.error?.idPlanning !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChangeForItem(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 col-span-2'>
                        {/* <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        <button className="edit-btn btns py-[10px] px-[20px] h-[40px]">Clear</button>
                        <button className="delete-btn btns py-[10px] px-[20px] h-[40px]">Delete</button> */}
                        {props.itemObject.keyId > 0 ?
                            <>
                                <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Update")}>Update</button>
                                <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.deleteItem(props.itemObject.keyId)}>Delete</button>
                            </>
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }
                    </div>
                </div>
                <div className="register-table h-[40vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    {/* <button className="print-btn btns">Print</button>
                    <button className="edit-btn btns">Preview</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}